import { FrameAction, FrameActionKey } from "../../actions/frame";
import { FrameEvent } from "../../types";

export const events = (
  state: FrameEvent[] = [],
  action: FrameAction
): FrameEvent[] => {
  switch (action.type) {
    case FrameActionKey.CAPTURE_FRAME_EVENT:
      // We only retain these when JupyterDevTools is opened.
      if (!action.payload.retain) {
        return state;
      }
      return [...state, action.payload.event];
    case FrameActionKey.CLEAR_FRAME_EVENTS:
      return [];
    default:
      return state;
  }
};
